import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save, X } from "lucide-react";

function Field({ label, required, children }) {
  return (
    <div className="space-y-1.5">
      <Label className="label-overline">
        {label} {required && <span className="text-red-600 ml-0.5">*</span>}
      </Label>
      {children}
    </div>
  );
}

export const AgencyRepForm = ({ editingId, draft, setDraft, busy, onSubmit, onCancel }) => (
  <Card className="rounded-sm border-zinc-300 bg-zinc-50" data-testid="agency-rep-edit-card">
    <CardContent className="p-5 space-y-3">
      <div>
        <div className="label-overline">{editingId ? "Edit team member" : "Add team member"}</div>
        <h3 className="font-display font-bold text-lg tracking-tight mt-1">
          {editingId ? "Update details" : "Who's working on this account?"}
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Field label="First name" required>
          <Input value={draft.first_name}
            onChange={(e) => setDraft({ ...draft, first_name: e.target.value })}
            placeholder="e.g. Trent" className="rounded-sm h-10 bg-white"
            data-testid="agency-rep-first-name-input" required />
        </Field>
        <Field label="Last name">
          <Input value={draft.last_name}
            onChange={(e) => setDraft({ ...draft, last_name: e.target.value })}
            placeholder="e.g. Roddan" className="rounded-sm h-10 bg-white"
            data-testid="agency-rep-last-name-input" />
        </Field>
        <Field label="Job title">
          <Input value={draft.title}
            onChange={(e) => setDraft({ ...draft, title: e.target.value })}
            placeholder="e.g. Marketing Director" className="rounded-sm h-10 bg-white"
            data-testid="agency-rep-title-input" />
        </Field>
        <Field label="Email">
          <Input type="email" value={draft.email}
            onChange={(e) => setDraft({ ...draft, email: e.target.value })}
            placeholder="name@icebergdigital.com.au" className="rounded-sm h-10 bg-white"
            data-testid="agency-rep-email-input" />
        </Field>
        <Field label="Phone">
          <Input value={draft.phone}
            onChange={(e) => setDraft({ ...draft, phone: e.target.value })}
            placeholder="+61 400 000 000" className="rounded-sm h-10 bg-white"
            data-testid="agency-rep-phone-input" />
        </Field>
      </div>
      <form onSubmit={onSubmit} className="flex items-center gap-2 pt-3 border-t border-zinc-200">
        <Button type="submit"
          disabled={busy || !draft.first_name}
          className="rounded-sm bg-zinc-900 hover:bg-black text-white"
          data-testid="agency-rep-save-button">
          <Save className="h-3.5 w-3.5 mr-1.5" />
          {busy ? "Saving…" : (editingId ? "Save changes" : "Add team member")}
        </Button>
        <Button type="button" variant="ghost" className="rounded-sm"
          onClick={onCancel} data-testid="agency-rep-cancel-button">
          <X className="h-3.5 w-3.5 mr-1" /> Cancel
        </Button>
        <p className="text-xs text-zinc-500 ml-2">
          Add the avatar from the row below after saving.
        </p>
      </form>
    </CardContent>
  </Card>
);
